import type { MutableRefObject } from "react";
import { linksHandler } from "../../../utils/links";
import type { FroalaEditorInstance } from "../types";

interface LinkData {
  event: string;
  url: string;
  type: string;
  status: string;
  openInPopup: boolean;
}

export const handleLink = (
  editor: FroalaEditorInstance,
  data: LinkData,
  lastRange: MutableRefObject<Range | null>,
  selectedText: MutableRefObject<string | null>,
  // Flags can be boolean or string ("true"/"false") depending on persistence
  // path; downstream `linksHandler` already coerces before applying.
  hyperLinkSettings: {
    isHyperLinkBold: boolean | string | undefined;
    isHyperLinkUnderline: boolean | string | undefined;
    isHyperLinkItalic: boolean | string | undefined;
  },
  refresh: () => void,
) => {
  if (!data) return;
  // Coerce string-form ("true"/"false") into proper booleans for the
  // downstream handler, which expects strict booleans.
  const coerce = (v: boolean | string | undefined): boolean =>
    v === true || v === "true";
  linksHandler(editor, lastRange.current, selectedText.current, data, {
    isHyperLinkBold: coerce(hyperLinkSettings.isHyperLinkBold),
    isHyperLinkUnderline: coerce(hyperLinkSettings.isHyperLinkUnderline),
    isHyperLinkItalic: coerce(hyperLinkSettings.isHyperLinkItalic),
  });
  editor.save.save();
  refresh();
};
